import React from "react";

/**
 * PendingRecordCell Component
 * Displays pending record with navigation capability
 * @param {Object} row - The row data object
 */
const PendingRecordCell = ({ row }) => {
  return (
    <span className={`text-primary-400 `}>
      {row.original.PendingRecord}
    </span>
  );
};

export default PendingRecordCell;
